import request from '../servises/request'

export function getGrossVolumeValue() {
    return request({
        url: '/analitics/gross-value',
        method: 'GET'
    })
}

export function getNewCustomers(date) {
    const [startDate, endDate] = date

    return request({
        url: `/analitics/new-customers?start=${startDate}&end=${endDate}`,
        method: 'GET'
    })
}

export function getSuccessfulPayments(date) {
    const [startDate, endDate] = date

    return request({
        url: `/analitics/successful-payments?start=${startDate}&end=${endDate}`,
        method: 'GET'
    })
}

export function getCustomersChart(date) {
    const [startDate, endDate] = date

    return request({
        url: `/analitics/customer-charts?start=${startDate}&end=${endDate}`,
        method: 'GET'
    })
}

export function getPlanCharts(date) {
    const [startDate, endDate] = date

    return request({
        url: `/analitics/plan-charts?start=${startDate}&end=${endDate}`,
        method: 'GET'
    })
}

export function getReportsChart(date) {
    const [startDate, endDate] = date

    return request({
        url: `/analitics/report-charts?start=${startDate}&end=${endDate}`,
        method: 'GET'
    })
}

export function getInterestReport(params) {
    return request({
        url: `/footprint?${params}`,
        method: 'GET'
    })
}

export function getInterestsTotalPrice(params) {
    return request({
        url: `/footprint/total-price?${params}`,
        method: 'GET'
    })
}

export function getFootprintFilters(params) {
    return request({
        url: `/footprint/filters`,
        method: 'GET'
    })
}

export function getFunnelFilters() {
    return request({
        url: `/footprint/unique-funnel`,
        method: 'GET'
    })
}

export function getPlanFilters() {
    return request({
        url: `/plan/list-plans`,
        method: 'GET'
    })
}

export function getCampaignFilters() {
    return request({
        url: `/footprint/unique-campaign`,
        method: 'GET'
    })
}
export function getSourceFilters() {
    return request({
        url: `/footprint/unique-source`,
        method: 'GET'
    })
}
